import { validator } from "LIB/validate-this";
import * as rules from "LIB/validation/rules";
import { AUTO_FOLLOWUP_DAYS } from "MODULES/OutgoingQuotes/constants";

export default function validate(values) {
  return validator(values, form => {
    if (values.auto_followup) {
      form.validate("to", AUTO_FOLLOWUP_DAYS).satisfies(rules.required);

      form.validate("to", "cc", "bcc").satisfies(rules.isValidEmail);

      form
        .validate(AUTO_FOLLOWUP_DAYS)
        .satisfies(
          rules.isGreaterThanOrEqualTo(1),
          rules.isLessThanOrEqualTo(14)
        );
    }
  });
}



// WEBPACK FOOTER //
// ./app/modules/OutgoingQuotes/Detail/AutoFollowup/validate.js